var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('editor',{attrs:{"docCreate":_vm.docCreate,"initial":_vm.dataItem},on:{"data":_vm.save}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }